(() => {
  const unavailable = new Set([
    '/collections/category', '/collections/brands', '/collections/cada',
    '/collections/ichiban-kuji', '/collections/mr-hobby', '/collections/platform-1',
    '/collections/oxford', '/collections/training-and-resources',
    '/collections/training', '/collections/resources'
  ]);
  const disable = (container) => {
    const links = container.matches?.('a[href]') ? [container] : [];
    links.push(...(container.querySelectorAll?.('a[href]') || []));
    for (const link of links) {
      try {
        const url = new URL(link.getAttribute('href'), location.href);
        if (url.hostname !== location.hostname && !['himp.com.au', 'hobbycoimports.myshopify.com'].includes(url.hostname)) continue;
        if (!unavailable.has(url.pathname.replace(/\/$/, ''))) continue;
        link.removeAttribute('href');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        link.style.cursor = 'default';
      } catch (_) {}
    }
  };
  disable(document);
  new MutationObserver((records) => {
    for (const record of records) {
      if (record.type === 'attributes') disable(record.target);
      else for (const node of record.addedNodes) if (node.nodeType === 1) disable(node);
    }
  }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
})();
